__turbopack_context__.v({
  "divider": "NavLanguageSwitcher-module-scss-module__0OWEoq__divider",
  "isOrderPage": "NavLanguageSwitcher-module-scss-module__0OWEoq__isOrderPage",
  "localSwitchDropdown": "NavLanguageSwitcher-module-scss-module__0OWEoq__localSwitchDropdown",
  "localeSwitchButton": "NavLanguageSwitcher-module-scss-module__0OWEoq__localeSwitchButton",
  "localeSwitchContainer": "NavLanguageSwitcher-module-scss-module__0OWEoq__localeSwitchContainer",
  "localeSwitchLabel": "NavLanguageSwitcher-module-scss-module__0OWEoq__localeSwitchLabel",
});
